/* =====================================================
   Adele Chérie — Cart 2026
   AJAX carrello standard Shopify (/cart/change.js, /cart/update.js)
   + Section Rendering API per ri-renderizzare la sezione.
   Degradazione: senza JS il form classico (updates[] / checkout) funziona.
   ===================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__acCartBound) return;
    root.__acCartBound = true;

    var sectionId = root.getAttribute('data-cart-section');

    function money(cents) {
      try {
        return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function setBusy(state) { root.setAttribute('data-busy', state ? 'true' : 'false'); }

    // Re-render della sezione via Section Rendering API
    function rerender() {
      return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-section]');
          if (fresh) {
            root.replaceWith(fresh);
            fresh.__acCartBound = false;
            init(fresh);
          }
        });
    }

    // Cambio quantità / rimozione tramite chiave riga
    function changeLine(key, quantity, itemEl) {
      setBusy(true);
      if (itemEl) itemEl.setAttribute('data-removing', '');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return rerender(); })
        .catch(function () { window.location.reload(); })
        .then(function () { setBusy(false); });
    }

    // ----- Quantity steppers -----
    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;
      var wrap = e.target.closest('[data-qty-wrap]');
      var input = wrap && wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      val = plus ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      changeLine(input.getAttribute('data-key'), val, e.target.closest('[data-cart-item]'));
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var val = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = val;
      changeLine(input.getAttribute('data-key'), val, e.target.closest('[data-cart-item]'));
    });

    // ----- Remove -----
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-remove]');
      if (!rm) return;
      e.preventDefault();
      changeLine(rm.getAttribute('data-key'), 0, e.target.closest('[data-cart-item]'));
    });

    // ----- Clear cart -----
    var clearBtn = root.querySelector('[data-cart-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        setBusy(true);
        fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
          .then(function () { return rerender(); })
          .catch(function () { window.location.reload(); })
          .then(function () { setBusy(false); });
      });
    }

    // ----- Order note (debounced) -----
    var noteEl = root.querySelector('[data-cart-note]');
    if (noteEl) {
      var noteTimer;
      noteEl.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ note: noteEl.value })
          });
        }, 600);
      });
    }

    // ----- Coupon (applica via URL /discount/CODE) -----
    var couponBtn = root.querySelector('[data-coupon-apply]');
    var couponInput = root.querySelector('[data-coupon-input]');
    if (couponBtn && couponInput) {
      var applyCoupon = function () {
        var code = (couponInput.value || '').trim();
        if (!code) { couponInput.focus(); return; }
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
      };
      couponBtn.addEventListener('click', applyCoupon);
      couponInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyCoupon(); }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-cart-section][data-section-type="ac-cart-2026"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Supporto Theme Editor (Shopify section load/select)
  document.addEventListener('shopify:section:load', boot);
})();
